<template>
  <div class="hr-bill">
    <!-- tab切换 -->
    <div class="hr-bill-top">
      <div class="switch-menu">
        <el-radio-group
          class="menu-name"
          v-for="(item, index) in menuList"
          :key="index"
          v-model="selectedTab"
          @change="toUrl(item.url)"
        >
          <el-radio-button :label="item.name"></el-radio-button>
        </el-radio-group>
      </div>
      <div class="btn-container">
        <div class="upload-warehouse" @click="exportExcel">
          <span class="upload-warehouse-img"></span>
          <span>导出</span>
        </div>
      </div>
    </div>

    <!-- 列表搜索 -->
    <div class="search">
      <el-form
        ref="searchForm"
        :model="search"
      >
        <div class="search-row">
          <el-form-item label="日期：">
            <el-date-picker
              v-if="search.select === 1"
              v-model="search.date"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
            <el-date-picker
              v-if="search.select === 2"
              v-model="search.month"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <div class="btn-operation">
            <el-button icon="el-icon-search" class="btn-blue" @click="searchList">搜索</el-button>
            <el-button icon="el-icon-refresh" class="btn-gray" @click="resetForm('searchForm')">重置</el-button>
          </div>
        </div>
      </el-form>
    </div>

    <div class="hr-bill-container">
      <div class="table" v-if="tableData.length">
        <el-table 
          :data="tableData" 
          style="width: 100%" 
          @selection-change="handleSelectionChange"
          :header-cell-class-name="headerCellClassName"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column
            v-for="(item, index) in tableTitleList"
            :key="index+1"
            :prop="item.prop"
            :label="item.label"
            show-overflow-tooltip
            :min-width="item.width"
            :class-name="item.alignment === 'right'?`cell-right-align-width`:''"
          >
            <template slot-scope="scope">
              <div v-if="item.prop === 'statusVal'" :class="`status${scope.row.status}`">{{ scope.row.statusVal }}</div>
              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="150"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                :class="scope.row.status == 1?'btn-text':'btn-text-gray'"
                :disabled="scope.row.status == 2"
                @click="batchVerification(scope.row.id)"
              >核实</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <pagination-tpl
            :total="total"
            :currentPage="currentPage"
            :pageSize="pageSize"
            @queryChange="queryChange"
          ></pagination-tpl>
        </div>
      </div>
      <div v-else class="nothing">
        <img class="nothing-img" src="~assets/images/nothing/nothing.png">
      </div>
    </div>

  </div>
</template>

<script>
import logisticsBillMixins from '@/common/mixins/logistics-bill.js'
export default {
  mixins: [logisticsBillMixins],

  data() {
    return {
      selectedTab: '日账单',
      search: {
        select: 1,
        date: "",
        month: "",
      },
    }
  },

  activated() {
    this.selectedTab = '日账单'
    this.search.select = 1
  },

  created() {
    this.initLogisticsBillList()
  },

  methods: {
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/operator/hr-bill.scss';
</style>
